import {
  NPVR_ADD_SERIE_INIT,
  NPVR_ADD_SERIE_SUCCESS,
  NPVR_ADD_SERIE_ERROR,
  NPVR_ADD_SERIE_CLEAR,
} from '../../actions/recording/constants';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NPVR_ADD_SERIE_INIT:
      return { ...state, loading: true, error: null, data: null };
    case NPVR_ADD_SERIE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case NPVR_ADD_SERIE_ERROR:
      return { ...state, loading: false, error: action.error, data: null };
    case NPVR_ADD_SERIE_CLEAR:
      return { ...state, loading: false, error: null, data: null };
    default:
      return state;
  }
};
